/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Box, Select } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { getSelectOptionsByTableName } from "../../../services/common.service";

const SelectWithComboAPI = ({
  placeholder,
  label,
  value,
  itemData,
  setValue,
  isRequired,
  onItemSelect,
  tableName,
  ...props
}) => {
  const [search, setSearch] = useState({
    enabled: true,
    text: "",
  });

  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  useEffect(() => {
    setSearch((prev) => ({ ...prev, enabled: true }));
  }, [itemData?.filters]);

  const dataQuery = useQuery({
    enabled: search.enabled,
    queryKey: [
      "data-select",
      tableName,
      JSON.stringify(itemData?.filters ?? { is_active_eq: true }),
      search.text,
    ],
    queryFn: () =>
      getSelectOptionsByTableName({
        tableName,
        filters: JSON.stringify(itemData?.filters) ?? `{"is_active_eq":true}`,
        page: -1,
        search: search.text,
      }),
    select: (data) => {
      let displayOptions = [];
      try {
        displayOptions = JSON.parse(itemData?.display_options || "[]");
      } catch {
        displayOptions = [itemData?.display_options];
      }

      const ifCheckQuantity = itemData?.filter_empty_quantity;
      
      if (ifCheckQuantity) {
        const hasAvailableItems = data.some(
          (item) => Number(item?.available_quantity) > 0
        );

        if (!hasAvailableItems) {
          return [];
        }
      }

      const filterData = ifCheckQuantity
        ? data.filter((item) => Number(item?.available_quantity) > 0)
        : data;

      return filterData.map((item) => {
        const label = displayOptions
          .map((opt) => getNestedValue(item, opt))
          .filter(Boolean)
          .join(" - ")
          .toUpperCase();

        const value = Array.isArray(itemData?.return_value)
          ? itemData.return_value
              .map((key) => getNestedValue(item, key))
              .join(" - ")
          : getNestedValue(item, itemData?.return_value);

        return {
          ...item,
          label,
          value: value?.toString(),
        };
      });
    },
  });

  return (
    <Box>
      <Select
        data={dataQuery.data ?? []}
        placeholder={placeholder}
        value={value?.toString() ?? null}
        searchable
        clearable
        withAsterisk={isRequired}
        searchValue={search.text}
        label={label}
        onSearchChange={(text) => setSearch({ enabled: true, text })}
        onChange={(selectedValue) => {
          if (!selectedValue) {
            setValue(null);
            setSearch({ enabled: true, text: "" });
            onItemSelect?.(null);
            return;
          }

          setValue(selectedValue);
          setSearch({ enabled: false, text: "" });

          const selectedItem = dataQuery.data?.find(
            (item) => item.value === selectedValue
          );
          onItemSelect?.(selectedItem);
        }}
        {...props}
      />
    </Box>
  );
};

export default SelectWithComboAPI;
